import React from 'react'
import Contact from '../components/Contact'

const ContactForm = () => {
  return <Contact />
}

export default ContactForm
